module.exports = __webpack_public_path__ + "static/media/Coursera-Logo.c6fc67b3.png";